export default {"src":"/_next/static/media/arrow-right-solid.90b75a9b.svg","height":512,"width":448};